import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { TArtist } from "../../types/artists";
import $api, { API } from "../index";

export const artistCard = createAsyncThunk(
  "artistCard",

  async (publicUrl: any, { rejectWithValue }): Promise<TArtist> => {
    try {
      const data = await $api.get(`${API.artistPath}${publicUrl}`);
      return data.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);
